var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "AppHeader",
    { attrs: { fixed: "" } },
    [
      _c("SidebarToggler", {
        staticClass: "d-lg-none",
        attrs: { display: "md", mobile: "" },
      }),
      _c("img", {
        staticClass: "d-lg-inline d-md-none d-sm-none bv-d-xs-down-none",
        staticStyle: { "margin-left": "10px" },
        attrs: {
          src: require("@/assets/img/brand/dt-logo-symbol.svg"),
          width: "30",
          height: "30",
          alt: "Dependency-Track Logo",
        },
      }),
      _c("SidebarToggler", {
        staticClass: "d-md-down-none",
        attrs: { display: "lg", defaultOpen: true },
      }),
      _c(
        "b-navbar-nav",
        { staticClass: "ml-auto" },
        [_c("DefaultHeaderProfileDropdown")],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }